import React from 'react';

import VpnTable from './VpnTable';

import { withAuthenticator } from 'aws-amplify-react';
import Amplify, { Auth } from 'aws-amplify';
import config from './config';
Amplify.configure(config);



class App extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div>
        <VpnTable />
      </div>
    );
  }

  showComponent = (theme) => {
    return (
      <div>
        <VpnTable />
      </div>
    );
  }
}

export default withAuthenticator(App, {
    signUpConfig: {
      hiddenDefaults: ["phone_number"],
      signUpFields: [
        { label: "Name", key: "name", required: true, type: "string" }
      ]
    }
  });
//export default App;



// WEBPACK FOOTER //
// ./src/App.js